import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../api';

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&display=swap');
@import url('https://api.fontshare.com/v2/css?f[]=clash-display@600,700&display=swap');
*,*::before,*::after{box-sizing:border-box;margin:0;padding:0;}
.auth-root{min-height:100vh;display:flex;align-items:center;justify-content:center;
  background:linear-gradient(145deg,#06112b 0%,#112359 60%,#1a3570 100%);
  font-family:'DM Sans',sans-serif;padding:20px;position:relative;overflow:hidden;}
.auth-root::before{content:'';position:fixed;inset:0;z-index:0;
  background-image:linear-gradient(rgba(28,115,186,0.05) 1px,transparent 1px),
    linear-gradient(90deg,rgba(28,115,186,0.05) 1px,transparent 1px);
  background-size:52px 52px;pointer-events:none;}
.auth-card{position:relative;z-index:1;width:100%;max-width:420px;
  background:rgba(13,31,69,0.85);border:1px solid rgba(28,115,186,0.22);
  border-radius:20px;padding:40px 36px;
  box-shadow:0 24px 80px rgba(0,0,0,0.5),inset 0 1px 0 rgba(255,255,255,0.06);}
@media(max-width:480px){.auth-card{padding:28px 20px;border-radius:14px;}}
.auth-logo{text-align:center;margin-bottom:24px;}
.auth-logo a{font-family:'Clash Display',sans-serif;font-size:2rem;font-weight:700;
  color:#fff;text-decoration:none;letter-spacing:-1px;}
.auth-logo a span{color:#f5a623;}
.auth-title{font-family:'Clash Display',sans-serif;font-size:1.5rem;font-weight:700;
  color:#fff;margin-bottom:4px;text-align:center;}
.auth-sub{font-size:13px;color:#64748b;text-align:center;margin-bottom:24px;}
.auth-alert{padding:11px 14px;border-radius:10px;font-size:13px;margin-bottom:16px;
  display:flex;align-items:flex-start;gap:8px;line-height:1.5;}
.auth-alert.error{background:rgba(248,113,113,0.1);border:1px solid rgba(248,113,113,0.25);color:#f87171;}
.auth-field{margin-bottom:14px;}
.auth-label{display:block;font-size:11px;font-weight:700;color:#94a3b8;
  text-transform:uppercase;letter-spacing:1.5px;margin-bottom:6px;}
.auth-label .opt{text-transform:none;font-weight:400;color:#475569;letter-spacing:0;font-size:10px;}
.auth-input{width:100%;padding:11px 14px;background:rgba(255,255,255,0.05);
  border:1px solid rgba(28,115,186,0.2);border-radius:10px;color:#e8f4fd;
  font-family:'DM Sans',sans-serif;font-size:14px;outline:none;transition:border 0.2s;}
.auth-input:focus{border-color:#2b8de0;}
.auth-input::placeholder{color:rgba(255,255,255,0.2);}
.auth-flapid-prefix{display:flex;align-items:center;background:rgba(28,115,186,0.1);
  border:1px solid rgba(28,115,186,0.2);border-radius:10px;overflow:hidden;}
.auth-flapid-prefix span{padding:11px 12px 11px 14px;color:#5aaef7;font-size:14px;
  border-right:1px solid rgba(28,115,186,0.2);white-space:nowrap;flex-shrink:0;}
.auth-flapid-prefix input{flex:1;background:transparent;border:none;padding:11px 14px;
  color:#e8f4fd;font-family:'DM Sans',sans-serif;font-size:14px;outline:none;}
.auth-pw-wrap{position:relative;}
.auth-pw-wrap .auth-input{padding-right:44px;}
.auth-pw-eye{position:absolute;right:12px;top:50%;transform:translateY(-50%);
  background:transparent;border:none;color:#64748b;cursor:pointer;font-size:15px;padding:2px;}
.auth-strength{height:3px;border-radius:99px;background:rgba(255,255,255,0.07);
  margin-top:8px;overflow:hidden;}
.auth-strength-bar{height:100%;border-radius:99px;transition:width 0.3s,background 0.3s;}
.auth-btn{width:100%;padding:13px;border-radius:11px;border:none;
  background:linear-gradient(135deg,#1c73ba,#2b8de0);color:#fff;
  font-family:'DM Sans',sans-serif;font-size:15px;font-weight:700;
  cursor:pointer;transition:all 0.18s;margin-top:8px;
  box-shadow:0 4px 14px rgba(28,115,186,0.4);}
.auth-btn:hover:not(:disabled){transform:translateY(-1px);}
.auth-btn:disabled{opacity:0.6;cursor:not-allowed;}
.auth-divider{display:flex;align-items:center;gap:12px;margin:18px 0;}
.auth-divider span{font-size:11px;color:#334155;text-transform:uppercase;
  letter-spacing:1px;white-space:nowrap;}
.auth-divider::before,.auth-divider::after{content:'';flex:1;height:1px;background:rgba(255,255,255,0.07);}
.auth-google-btn{width:100%;padding:12px;border-radius:11px;border:1px solid rgba(255,255,255,0.12);
  background:rgba(255,255,255,0.05);color:#e8f4fd;font-family:'DM Sans',sans-serif;
  font-size:14px;font-weight:600;cursor:pointer;transition:all 0.18s;
  display:flex;align-items:center;justify-content:center;gap:10px;}
.auth-google-btn:hover{background:rgba(255,255,255,0.1);}
.auth-google-icon{width:18px;height:18px;flex-shrink:0;}
.auth-footer{text-align:center;margin-top:20px;font-size:13px;color:#475569;}
.auth-footer a{color:#5aaef7;text-decoration:none;font-weight:600;}
`;

function pwStrength(pw) {
  if (!pw) return { pct: 0, color: 'transparent', label: '' };
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[A-Z]/.test(pw)) s++;
  if (/[0-9]/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  if (s <= 1) return { pct: 20, color: '#f87171', label: 'Weak' };
  if (s <= 2) return { pct: 40, color: '#fbbf24', label: 'Fair' };
  if (s <= 3) return { pct: 65, color: '#60a5fa', label: 'Good' };
  return { pct: 100, color: '#34d399', label: 'Strong' };
}

const GoogleIcon = () => (
  <svg className="auth-google-icon" viewBox="0 0 24 24">
    <path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
    <path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
    <path fill="#FBBC05" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
    <path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
  </svg>
);

export default function Register() {
  const [flapid,   setFlapid]   = useState('');
  const [email,    setEmail]    = useState('');
  const [password, setPassword] = useState('');
  const [showPw,   setShowPw]   = useState(false);
  const [error,    setError]    = useState('');
  const [loading,  setLoading]  = useState(false);
  const navigate = useNavigate();
  const strength = pwStrength(password);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !password.trim()) { setError('Email and password are required.'); return; }
    if (password.length < 6) { setError('Password must be at least 6 characters.'); return; }
    setLoading(true);
    try {
      const payload = { email: email.trim(), password };
      if (flapid.trim()) payload.flapid = flapid.trim().toLowerCase();
      const { data } = await api.post('/auth/register', payload);
      localStorage.setItem('token', data.token);
      navigate('/profile');
    } catch (err) {
      setError(err.response?.data?.error || err.response?.data?.msg || 'Registration failed. Try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = () => {
    window.location.href = `${(process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace('/api','')}/api/auth/google`;
  };

  return (
    <div className="auth-root">
      <style>{CSS}</style>
      <div className="auth-card">
        <div className="auth-logo"><a href="/">flap<span>.</span></a></div>
        <h1 className="auth-title">Create account</h1>
        <p className="auth-sub">Join Flap — your digital identity</p>

        {error && <div className="auth-alert error">⚠️ {error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="auth-field">
            <label className="auth-label">Flap ID <span className="opt">()</span></label>
            <div className="auth-flapid-prefix">
              <span>flaap.me/</span>
              <input value={flapid} placeholder="yourname"
                onChange={e => setFlapid(e.target.value.toLowerCase().replace(/[^a-z0-9_-]/g, ''))}
                autoComplete="off" spellCheck="false"/>
            </div>
          </div>

          <div className="auth-field">
            <label className="auth-label">Email</label>
            <input className="auth-input" type="email" value={email}
              onChange={e => setEmail(e.target.value)} required
              placeholder="you@email.com" autoComplete="email"/>
          </div>

          <div className="auth-field">
            <label className="auth-label">Password</label>
            <div className="auth-pw-wrap">
              <input className="auth-input" type={showPw ? 'text' : 'password'}
                value={password} onChange={e => setPassword(e.target.value)}
                required minLength={6} placeholder="At least 6 characters"
                autoComplete="new-password"/>
              <button type="button" className="auth-pw-eye"
                onClick={() => setShowPw(p => !p)}>{showPw ? '🙈' : '👁'}</button>
            </div>
            {password && (
              <div className="auth-strength">
                <div className="auth-strength-bar" style={{width:`${strength.pct}%`,background:strength.color}}/>
              </div>
            )}
          </div>

          <button type="submit" className="auth-btn" disabled={loading}>
            {loading ? '⏳ Creating…' : 'Create Account'}
          </button>
        </form>

        <div className="auth-divider"><span>or sign up with</span></div>

        <button type="button" className="auth-google-btn" onClick={handleGoogle}>
          <GoogleIcon/>
          Sign up with Google
        </button>

        <p className="auth-footer">
          Already have an account? <Link to="/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}